import colors from '../foundation/colors';

/**
 * Customized Input component.
 *
 * Reference: https://chakra-ui.com/docs/theming/customize-theme
 * Figma Reference: https://www.figma.com/file/Z8kfGR6BNKMm3XvQGhKcBD/PINS-Advantage-2021-Design-System?node-id=5%3A3
 */
export const inputFocusStyle = {
  border: '0px',
  outline: 'none',
  boxShadow: `inset 0 0 0 1px ${colors.primaryScale['600']}`,
  bgColor: 'white',
  _hover: { bgColor: 'white' }
};

const Input = {
  baseStyle: {
    field: {
      _autofill: { bg: 'transparent !important' },
      fontSize: 'sm'
    },
    addOn: {
      color: 'greyScale.600',
      boxSize: '24px'
    }
  },
  variants: {
    standard: props => {
      const cursorStyle = props?.isDisabled ? 'not-allowed' : 'auto';
      const placeHolderColorStyle = props?.isDisabled ? colors.greyScale['500'] : '';
      const colorStyle = props?.isDisabled ? colors.greyScale['500'] : colors.greyScale['900'];

      return {
        field: {
          _autofill: { boxShadow: `0 0 0px 1000px ${colors.greyScale['100']} inset` },
          _active: { bg: 'transparent' },
          _hover: { cursor: cursorStyle },
          _placeHolder: { color: placeHolderColorStyle },
          bgColor: 'transparent',
          color: colorStyle,
          fontSize: '15px',
          paddingLeft: '16px'
        }
      };
    },
    primary: {
      field: {
        _autofill: { boxShadow: `0 0 0px 1000px ${colors.greyScale['100']} inset` },
        _disabled: { opacity: 0.5, cursor: 'not-allowed' },
        _focus: inputFocusStyle,
        _hover: {
          bgColor: 'greyScale.100',
          _disabled: {
            bgColor: 'greyScale.100',
            opacity: 0.5,
            cursor: 'not-allowed'
          }
        },
        _active: {
          border: '0px',
          outline: 'none',
          boxShadow: `inset 0 0 0 1px ${colors.primaryScale['600']}`,
          bgColor: 'white'
        },
        _placeHolder: { color: 'greyScale.500' },
        background: 'greyScale.100',
        color: 'greyScale.900',
        textStyle: 'bodyMd',
        borderRadius: 'md',
        border: '0px',
        borderColor: 'transparent'
      }
    },
    secondary: {
      field: {
        _autofill: { boxShadow: '0 0 0px 1000px #FFFFFF inset' },
        _disabled: { opacity: 0.5, cursor: 'not-allowed' },
        _focus: inputFocusStyle,
        _hover: {
          bgColor: 'white',
          _disabled: {
            bgColor: 'white',
            opacity: 0.5,
            cursor: 'not-allowed'
          }
        },
        _active: {
          border: '0px',
          outline: 'none',
          boxShadow: `inset 0 0 0 1px ${colors.primaryScale['600']}`,
          bgColor: 'white'
        },
        _placeHolder: { color: 'greyScale.500' },
        background: 'white',
        color: 'greyScale.900',
        textStyle: 'bodyMd',
        borderRadius: 'md',
        border: '0px',
        borderColor: 'transparent'
      }
    },
    sizes: {
      sm: { field: { height: '32px', fontSize: '15px' } },
      md: { field: { height: '40px', fontSize: '15px' } },
      lg: { field: { height: '48px', fontSize: '15px' } }
    }
  },
  defaultProps: { variant: 'primary' }
};

export default Input;
